export enum IconSource {
    Material = 1,
    MiPro
}
